import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: 'ng-template[fc-tab-label]',
})
export class FcTabLabel {
  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
